import React from "react";
import AppTheme from "../../../../service/app_config/AppTheme";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import { ChatMediaContextImport } from "../../../../provider/chats/chats/chat_media/ChatMediaContextProvider";

const ChatMediaActions = () => {
  const { longPressStatus, handleDelete, handleSend } =
    ChatMediaContextImport();

  return (
    <>
      {longPressStatus && (
        <>
          <IconNormal
            name="delete2"
            color={AppTheme.themeFont}
            handleClick={() => handleDelete()}
          />

          <IconNormal
            name="forward2"
            size={35}
            color={AppTheme.themeFont}
            handleClick={() => handleSend()}
          />
        </>
      )}
    </>
  );
};

export default ChatMediaActions;
